import { Component } from '@angular/core';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { CommonModule } from '@angular/common';
import { UserRightService } from '../../../Model/UserRight/user-right.service';
import { Router } from '@angular/router';
import { SessionService } from '../../../Util/Session/session.service';
import { CommonService } from '../../../Model/Common/common.service';
import { ReportsService } from '../../../Model/Reports/reports.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';

@Component({
  selector: 'app-front-report',
  standalone: true,
  imports: [LoaderComponent, CommonModule,],
  templateUrl: './front-report.component.html',
  styleUrl: './front-report.component.scss'
})
export class FrontReportComponent {
  isDisabled: boolean = false;
  menus = [] as any;
  user = [] as any
  constructor(
    private userright: UserRightService,
    private router: Router,
    private session: SessionService,
    private common: CommonService,
    private report: ReportsService,
    private toast: ToastService
  ) {
    this.user = this.session.GetUserDetails();
  }

  ngOnInit() {
    this.ESS_ProfileMenuRightsView();
  }

  ESS_ProfileMenuRightsView() {
    this.userright.ESS_ProfileMenuRightsView({ SelectType: 'View' }).subscribe({
      next: (response) => {
        try {
          this.menus = response.filter((e: any) => e.ESS_MenuMasterId == 58)[0].SubMenus.filter((e: any) => e.ESS_MenuMasterId == 59)[0];
          // const submenu = this.menus.SubMenus.find((e: any) => e.MenuLabel == 'Other Reports')
          // submenu.SubMenus.push({
          //   AddApplicable: false,
          //   DeleteApplicable: false,
          //   ESS_MenuMasterId: 62,
          //   EditApplicable: false,
          //   Icon: "outdoor.png",
          //   IsActive: true,
          //   IsExternal: false,
          //   IsNewTab: false,
          //   MenuLabel: "Outdoor Report",
          //   MenuLevel: 4,
          //   MenuOrder: 1,
          //   MenuParentId: 61,
          //   PrintApplicable: true,
          //   ProfileMasterID: 1,
          //   ProfileName: "SUPER ADMINISTRATOR",
          //   SubMenus: [],
          //   URL: "reports/report/view/f/18",
          // })
          // console.log(this.menus);
        } catch (e) { this.menus = [] }
      },
      complete: () => { },
      error: (error) => { },
    });
  }

  ReportPage(menuid: number, url: String) {
    this.common.selectedmenuID = menuid
    // this.user.selectedmenuID = menuid;
    // this.session.Start(this.user);
    this.router.navigate([url]);
  }

  // navigateToCommonReport() {
  //   this.router.navigate(['/reports/report/view', 'f', 15]);
  // }
}